export default __webpack_public_path__ + "static/media/logoCityVision.11c57313.png";